import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { CuentaBeneficiario } from 'src/app/dashboard/interfaces/cuenta-beneficiario.interface';
import { WalletVesClientService } from 'src/app/dashboard/services/wallet-ves-client.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-withdraw-summary-order-ves',
  templateUrl: './withdraw-summary-order-ves.component.html',
  styleUrls: ['./withdraw-summary-order-ves.component.sass']
})
export class WithdrawSummaryOrderVesComponent {
  isSubmitting = false;
  // Comisión Aguacate 0.3% — debe coincidir con el backend (RETIRO_VES_COMISION_RATE).
  readonly COMISION_RATE = 0.003;

  constructor(
    private spinnerService: SpinnerService,
    private walletVesService: WalletVesClientService,
    private router: Router,
  ){}

  @Input()
  public montoRetiro: number = 0;

  @Input()
  public account: CuentaBeneficiario | undefined;

  @Input()
  public usuarioId: number | undefined;

  @Output()
  public goBack = new EventEmitter<any>();

  // Comisión 0.3% (mismo redondeo que el backend: 2 decimales)
  get comisionVes(): number {
    return Math.round(this.montoRetiro * this.COMISION_RATE * 100) / 100;
  }

  // Monto neto que recibe el beneficiario = monto retirado - comisión
  get montoRecibido(): number {
    return Math.round((this.montoRetiro - this.comisionVes) * 100) / 100;
  }

  async confirmarEnvio(){
    this.isSubmitting = true;
    const ref = this.spinnerService.start();

    const dto = {
      userId: this.usuarioId!,
      totalMonedaOrigen: +this.montoRetiro,
      cuentaBeneficiarioId: this.account?.cuentaBeneficiarioID!,
    };

    try {
      await firstValueFrom(this.walletVesService.retiroVes(dto));
      this.spinnerService.stop(ref);
      Swal.fire({ title: 'Retiro creado', text: 'Tu retiro VES ha sido creado exitosamente. Pendiente de aprobaci\u00f3n.', icon: 'success', confirmButtonColor: '#1e5a3f' });
      this.router.navigate(['/wallet/home']);
    } catch(error: any) {
      this.isSubmitting = false;
      this.spinnerService.stop(ref);
      Swal.fire({
        title: 'Error al retirar',
        text: error?.message || 'Ha ocurrido un error al realizar el retiro',
        icon: 'warning',
        confirmButtonColor: '#1e5a3f'
      }).then(() => {
        this.router.navigate(['/wallet/client/withdraw-ves']);
      });
    }
  }

  goToBack(): void {
    this.goBack.emit();
  }
}
